import { CSSProperties, FC, useEffect, useRef } from 'react';

export const PRIMIS_OUTSTREAM_CONTAINER_ID = 'primis-player-container';
export const PRIMIS_PLAYER_SCRIPT_SRC = 'https://live.primis.tech/live/liveView.php?s=122375';

const primisOutstreamContainerStyle: CSSProperties = {
  height: 0,
  minHeight: 0,
  lineHeight: 0,
  fontSize: 0,
  overflow: 'visible'
};

function createPrimisScript() {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = PRIMIS_PLAYER_SCRIPT_SRC;
  script.setAttribute('language', 'javascript');
  return script;
}

export const PrimisOutstream: FC = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    const script = createPrimisScript();
    container.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <div id={PRIMIS_OUTSTREAM_CONTAINER_ID} ref={containerRef} style={primisOutstreamContainerStyle} />
  );
};
